export enum EntityType {
  Site = 'site',
  Sector = 'secteur',
  Route = 'voie'
}

export enum KeyStorage {
  Sites = 'sites',
  Content = 'content',
  SectorsOffline = 'sectorsOffline',
  Photos = "photo_"
}

export interface Photo {
  name: string;
  url: string;
}

export enum ContentId {
  Book = 'book',
  EnvironmentalAlert = 'environmentalAlert',
  Contact = 'contactAndPartenaires'
}

export interface StorageImage {
  dataBase64: string;
  sectors: number[];
}

export interface ImageSize {
  width: number;
  height: number;
}

export interface Content {
  id: string;
  text: string;
  lastUpdate: Date;
}

export interface LastUpdate {
  sites: Date,
  book: Date,
  environmentalAlert: Date,
  contact: Date,
}

export interface Site {
  id: number;
  name: string;
  description: string;
  location: Location;
  sectors: Sector[];
  photos: string[];
  lastUpdate: Date;
}

export interface Sector {
  id: number;
  siteId: number;
  name: string;
  type: SectorType;
  description: string;
  environmentalAlert: string;
  location: Location;
  routes: Route[];
  photos: string[];
  lastUpdate: Date;
  photoPaths: PhotoPath[];
  parking: Location;
}

export interface Route {
  id: number;
  sectorId: number;
  siteId: number;
  number: number;
  name: string;
  description: string;
  difficulty: DifficultyRoute | DifficultyVia;
  height: string;
  lastUpdate: Date;
}

export interface PhotoPath {
  photo: string,
  routePaths: RoutePath[];
  pois: Poi[];
}

export interface RoutePath {
  polyline: number[][];
  routeId: number;
}

export interface Poi {
  lat: number;
  lng: number;
  description: string;
  photo: string;
  type: PoiType;
}

export interface Location {
  latitude: number;
  longitude: number;
}

export interface SiteResult {
  site: Site,
  sectorResults: SectorResult[],
}

export interface SectorResult {
  sector: Sector,
  routeResults: Route[],
}

export interface SearchFilter {
  name: string
  isDifficultyRoute: boolean,
  difficultyRoute : {
    lower : number
    upper: number
  },
  isDifficultyVia: boolean,
  difficultyVia: {
    lower : number
    upper: number
  },
  isDistance: boolean,
  distance: number,
  isSectorType: boolean,
  sectorType : any
}

export enum SectorType {
  SchoolCliff = "Falaise ecole",
  ViaFerrata = "Via Ferrata",
  LongRoute = "Grande voie"
}

export enum PoiType {
  EnvironmentalAlert = 'Alerte environnementale',
  AlerteSecurite = 'Alerte sécurité',
  Cotation = 'Cotation',
  DescenteLeft = 'Descente G',
  DescenteRight = 'Descente D',
  RelaisEquipeRappel = 'relais équipé pour le rappel',
  RelaisNotEquipeRappel = 'relais non-équipé pour le rappel',
  Photo = 'Photo',
  ApprocheLeft = 'Approche - Attaque G',
  ApprocheRight= 'Approche - Attaque D'
}

export enum DifficultyRoute {
  Trois = '3',
  TroisPlus = '3+',
  QuatreA = '4a',
  QuatreB = '4b',
  QuatreC = '4c',
  CinqA = '5a',
  CinqB = '5b',
  CinqC = '5c',
  SixA = '6a',
  SixAPlus = '6a+',
  SixB = '6b',
  SixBPlus = '6b+',
  SixC = '6c',
  SixCPlus = '6c+',
  SeptA = '7a',
  SeptAPlus = '7a+',
  SeptB = '7b',
  SeptBPlus = '7b+',
  SeptC = '7c',
  SeptCPlus = '7c+',
  HuitA = '8a',
  HuitAPlus = '8a+',
  HuitB = '8b',
  HuitBPlus = '8b+',
  HuitC = '8c',
  HuitCPlus = '8c+',
  NeufA = '9a',
  NeufAPlus = '9a+'
}

export enum DifficultyVia {
  F = 'F',
  PD = 'PD',
  AD = 'AD',
  D = 'D',
  TD = 'TD',
  ED = 'ED',
}



// WEBPACK FOOTER //
// ./src/models/data.model.ts